import { fmtCompact } from "@/lib/format";

export const PAIRS = [
  { id: "actual_budget", a: "actual", b: "budget", label: "Actual vs Budget" },
  { id: "actual_ly", a: "actual", b: "ly", label: "Actual vs LY" },
  { id: "actual_forecast", a: "actual", b: "forecast", label: "Actual vs Rolling Forecast" },
  { id: "budget_ly", a: "budget", b: "ly", label: "Budget vs LY" },
  { id: "forecast_budget", a: "forecast", b: "budget", label: "Rolling Forecast vs Budget" },
];

export const agg = (arr, upto, avg) => {
  const v = (arr || []).slice(0, upto).filter((x) => x !== null && x !== undefined);
  if (!v.length) return null;
  const s = v.reduce((p, c) => p + c, 0);
  return avg ? s / v.length : s;
};

export const pick = (k, series, view, month) => {
  if (view === "month") return k[series]?.[month - 1] ?? null;
  if (view === "ytd") return agg(k[series], month, k.avg);
  if (series === "actual" && (k.actual || []).filter((x) => x !== null).length < 12) return null;
  return agg(k[series], 12, k.avg);
};

export const pickKpi = (data, key, series, view, month) => {
  if (key === "gop_margin" && data.kpis.gop && data.kpis.revenue) {
    const g = pick(data.kpis.gop, series, view, month), r = pick(data.kpis.revenue, series, view, month);
    return g === null || !r ? null : (g / r) * 100;
  }
  return pick(data.kpis[key], series, view, month);
};

export const fmtKpi = (key, v, k) => {
  if (v === null || v === undefined) return "-";
  if (key === "gop_margin") return `${v.toFixed(2)}%`;
  if (key === "occupancy" || k?.is_ratio) return `${(Math.abs(v) <= 1.5 ? v * 100 : v).toFixed(2)}%`;
  if (key === "rooms_sold" || key === "adr" || key === "revpar") return Math.round(v).toLocaleString("en-US");
  return fmtCompact(v);
};

const isPoints = (key) => key === "gop_margin" || key === "occupancy";

export const delta = (key, a, b) => {
  if (a === null || b === null || a === undefined || b === undefined) return null;
  if (isPoints(key)) { const s = key === "occupancy" && Math.abs(b) <= 1.5 ? 100 : 1; return { v: (a - b) * s, pt: true }; }
  if (!b) return null;
  return { v: ((a - b) / Math.abs(b)) * 100, pt: false };
};

export const fmtDelta = (d) => (d === null ? "-" : `${d.v > 0 ? "+" : ""}${d.v.toFixed(2)}${d.pt ? " pt" : "%"}`);
